<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <BreadCrumd
          :title="'Inventaires'"
          :description="'Modification d\'un inventaire'"
        />
      </div>
      <div class="col-md-6 mt-4" v-if="form.document">
        <div class="row">
          <div class="col-md-12">
            <table
              class="card table table-sm table-custom-primary table-bordered mb-0"
            >
              <tbody>
                <tr class="d-flex font-size-17 font-weight-bold">
                  <td class="col-12 text-custom-primary">
                    Référence : {{ form.document.reference }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-md-12 col-lg-6">
        <button
          type="button"
          class="btn btn-secondary mr-4"
          @click.prevent="
            $router.push({ name: 'achat_inventaire' }).catch(() => {})
          "
        >
          Liste des inventaires
        </button>

        <button
          type="button"
          class="btn btn-custom-primary mr-4"
          @click.prevent="
            $router.push({ name: 'achat_inventaire-create' }).catch(() => {})
          "
        >
          <i class="fas fa-plus"></i>
          Nouvel inventaire
        </button>

        <button
          type="button"
          class="btn btn-custom-primary"
          style="min-width: 100px"
          @click.prevent="
            $router
              .push({
                name: 'achat_inventaire-show',
                params: { id: id },
              })
              .catch(() => {})
          "
        >
          <i class="fa fa-eye font-size-17"></i> Aperçu
        </button>
      </div>
    </div>

    <div class="mt-4 mb-4">
      <form @submit.prevent="submit" @keydown="form.onKeydown($event)">
        <alert-error
          v-if="form.errors.get('message')"
          :form="form"
          :message="form.errors.get('message')"
        ></alert-error>
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body mb-n2">
                <div class="row justify-content-lg-center">
                  <div class="col-md-6 col-lg-2">
                    <div class="form-group">
                      <label for="date_debut"
                        >Date début <span class="text-danger">*</span></label
                      >
                      <date-picker
                        type="date"
                        v-model="form.date_debut"
                        name="date_debut"
                        placeholder="Date début"
                        lang="fr"
                        format="DD/MM/YYYY"
                        value-type="DD/MM/YYYY"
                      ></date-picker>
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('date_debut'),
                        }"
                        type="hidden"
                      />
                      <has-error :form="form" field="date_debut"></has-error>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-2">
                    <div class="form-group">
                      <label for="date_fin">Date fin </label>
                      <date-picker
                        v-model="form.date_fin"
                        name="date_fin"
                        placeholder="Date fin"
                        lang="fr"
                        format="DD/MM/YYYY"
                        value-type="DD/MM/YYYY"
                      ></date-picker>
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('date_fin'),
                        }"
                        type="hidden"
                      />
                      <has-error :form="form" field="date_fin"></has-error>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-3">
                    <div class="form-group">
                      <label for="entrepot"
                        >Entrepôt <span class="text-danger">*</span></label
                      >
                      <v-custom-select
                        label="nom"
                        :options="entrepots"
                        :reduce="(entrepot) => entrepot.uuid"
                        v-model="form.entrepot"
                        placeholder="Entrepôt"
                        @input="onChangeEntrepot"
                      >
                        <template v-slot:option="{ nom, pays, description }">
                          <h5 style="margin: 0">{{ nom }}</h5>
                          <span v-if="pays" class="d-block">
                            Pays : {{ pays }}
                          </span>
                          <span v-if="description" class="d-block">
                            Description : {{ description }}
                          </span>
                        </template>
                        <template #no-options> Aucune donnée </template>
                        <template #search="{ attributes, events }">
                          <input
                            id="entrepot"
                            class="custom-select-height vs__search"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </v-custom-select>
                      <div>
                        <input
                          type="hidden"
                          class="form-control"
                          :class="{
                            'is-invalid': form.errors.has('entrepot'),
                          }"
                        />
                        <has-error :form="form" field="entrepot"></has-error>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-1 mt-n4 mt-lg-0">
                    <div class="custom-control custom-checkbox mt-4 pt-2">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="brouillon"
                        v-model="form.brouillon"
                      />
                      <label class="custom-control-label" for="brouillon"
                        >Brouillon</label
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-n4">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body mt-n2 mb-n2">
                <div class="row mt-n2 d-flex justify-content-center">
                  <div class="col-md-8 col-lg-6">
                    <cool-select
                      v-model="selectedArticle"
                      :items="articles"
                      item-text="designation"
                      placeholder="Recherche article"
                      disable-filtering-by-search
                      @search="onSearchArticle"
                      @select="onSelectedArticle"
                      :search-text.sync="searchText"
                    >
                      <template #no-data>
                        {{
                          noData
                            ? 'Aucun resultat.'
                            : '2 caratères pour lancer la recherche.'
                        }}
                      </template>
                      <template #item="{ item }">
                        <div class="item">
                          <div>
                            <h5>{{ item.designation }}</h5>
                            <span v-if="item.reference" class="d-block">
                              Référence : {{ item.reference }}
                            </span>
                            <span v-if="item.unite" class="d-block">
                              Unité : {{ item.unite }}
                            </span>
                            <span v-if="item.article_type" class="d-block">
                              Type d'article :
                              {{
                                item.article_type === 'produits'
                                  ? 'Produit'
                                  : 'Service'
                              }}
                            </span>
                          </div>
                        </div>
                      </template>
                    </cool-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <b-alert
          :show="itemListErrorMessage !== null"
          dismissible
          variant="danger"
        >
          <span v-html="itemListErrorMessage"></span>
        </b-alert>
        <div class="row mt-n4">
          <div class="col-md-12">
            <table class="card table table-sm">
              <thead>
                <tr class="d-flex">
                  <th class="col-4">Produit</th>
                  <th class="col-2">Stock</th>
                  <th class="col-2 text-center">N° Lot</th>
                  <th class="col-1 text-center">DLC</th>
                  <th class="col-1 text-center">DLUO</th>
                  <th class="col-1 text-center">Quantité</th>
                  <th class="col-1 text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in item_lists" :key="index">
                  <td class="col-4" style="vertical-align: middle">
                    Désignation : {{ item.designation }} <br />
                    Réference : {{ item.reference }} <br />
                    Gestion par lot :
                    {{ item.gestion_lot === true ? 'Oui' : 'Non' }}
                  </td>

                  <td class="col-2" style="vertical-align: middle">
                    <span
                      v-if="item.gestion_lot && !item.lot_uuid"
                      class="text-danger"
                    >
                      Choisir un lot
                    </span>
                    <span v-else>
                      {{ item.stock + ' ' + item.unite }}
                    </span>
                  </td>

                  <template v-if="item.gestion_lot">
                    <td class="col-2" style="vertical-align: middle">
                      <v-custom-select
                        label="lot"
                        :options="item.lots"
                        :reduce="(lot) => lot.lot_uuid"
                        v-model="item.lot_uuid"
                        placeholder="N° Lot"
                        @input="onChangeLot(item)"
                      >
                        <template v-slot:option="{ lot, dlc, dluo }">
                          <h5 style="margin: 0">{{ lot }}</h5>
                          <span v-if="dlc" class="d-block">
                            DLC : {{ dlc }}
                          </span>
                          <span v-if="dluo" class="d-block">
                            DLUO : {{ dluo }}
                          </span>
                        </template>
                        <template #no-options> Aucune donnée </template>
                        <template #search="{ attributes, events }">
                          <input
                            id="lot"
                            class="custom-select-height vs__search"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </v-custom-select>
                    </td>
                    <td
                      class="col-1 text-center"
                      style="vertical-align: middle"
                    >
                      {{ item.dlc ? item.dlc : '###' }}
                    </td>
                    <td
                      class="col-1 text-center"
                      style="vertical-align: middle"
                    >
                      {{ item.dluo ? item.dluo : '###' }}
                    </td>
                  </template>
                  <template v-else>
                    <td
                      class="col-2 text-center"
                      style="vertical-align: middle"
                    >
                      ###
                    </td>
                    <td
                      class="col-1 text-center"
                      style="vertical-align: middle"
                    >
                      ###
                    </td>
                    <td
                      class="col-1 text-center"
                      style="vertical-align: middle"
                    >
                      ###
                    </td>
                  </template>

                  <td class="col-1" style="vertical-align: middle">
                    <input
                      class="form-control"
                      v-model="item.quantite"
                      type="text"
                      placeholder="Quantité"
                      @focus="$event.target.select()"
                    />
                  </td>
                  <td class="col-1 text-center" style="vertical-align: middle">
                    <a
                      v-if="item.gestion_lot"
                      class="cursor-pointer"
                      @click.prevent="showModalLot(item)"
                    >
                      <i class="fa fa-plus font-size-17 text-success mr-4"></i
                    ></a>
                    <a
                      class="cursor-pointer"
                      @click.prevent="removeItem(index)"
                    >
                      <i class="fa fa-trash font-size-17 text-danger"></i
                    ></a>
                  </td>
                </tr>
                <tr v-if="item_lists.length === 0" class="d-flex">
                  <td colspan="6" class="text-center col-12">Aucune donnée</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="row mb-4 mt-2">
          <div class="col-md-12 text-right">
            <ButtonLoader
              :busy="form.busy"
              type="submit"
              customClass="btn btn-custom-primary w-40"
              loadText="Traitement en cours..."
              Text="Enregistrer"
              style="min-width: 100px"
            ></ButtonLoader>
          </div>
        </div>
      </form>
    </div>
    <ModalLot
      ref="modalLot"
      :currentItem="currentItem"
      @onAddNewLot="onAddNewLot"
    />
  </div>
</template>

<script>
import URL_INV from '@/http/article_stock/inventaire';
import URL_A from '@/http/article_stock/article';
import Form from 'vform';
import { CoolSelect } from 'vue-cool-select';
import DatePicker from 'vue2-datepicker';
import ModalLot from '../components/ModalLot.vue';
import { uuid } from 'vue-uuid';

export default {
  data() {
    return {
      form: new Form({
        date_debut: '',
        date_fin: '',
        reference: '',
        entrepot: '',
        brouillon: false,
      }),

      item_lists: [],
      articles: [],
      entrepots: [],
      selectedArticle: null,
      noData: false,
      timeoutId: null,
      searchText: null,

      currentItem: null,

      itemListErrorMessage: null,
      title: 'Gestion des inventaires - Edition',
    };
  },
  components: {
    CoolSelect,
    DatePicker,
    ModalLot,
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  methods: {
    onChangeEntrepot() {
      //this.item_lists = [];
      this.currentItem = null;
    },

    onChangeLot(item) {
      this.stockArticle(item);
    },

    showModalLot(item) {
      this.currentItem = item;
      this.$nextTick(() => {
        this.$refs.modalLot.showModal(null);
      });
    },
    onAddNewLot(currentItem, lot, dlc, dluo) {
      let check = window._.find(
        currentItem.lots,
        (l) => l.lot === lot && l.dlc === dlc && l.dluo === dluo
      );
      if (!check) {
        let itemLot = {
          lot_uuid: uuid.v4(),
          entrepot_uuid: this.form.entrepot,
          lot: lot,
          dlc: dlc,
          dluo: dluo,
          quantite: 0,
        };
        currentItem.lots.push(itemLot);

        currentItem.lot_uuid = itemLot.lot_uuid;
        currentItem.lot = itemLot.lot;
        currentItem.dlc = itemLot.dlc;
        currentItem.dluo = itemLot.dluo;
        this.onChangeLot(currentItem);
      } else {
        currentItem.lot_uuid = check.lot_uuid;
        currentItem.lot = check.lot;
        currentItem.dlc = check.dlc;
        currentItem.dluo = check.dluo;
        this.onChangeLot(currentItem);
      }
    },
    stockArticle(item) {
      if (item.gestion_lot) {
        let currentLot = window._.find(
          item.lots,
          (l) =>
            l.entrepot_uuid === this.form.entrepot &&
            l.lot_uuid === item.lot_uuid
        );
        item.stock = currentLot ? currentLot.quantite : 0;
        item.lot = currentLot ? currentLot.lot : null;
        item.dlc = currentLot ? currentLot.dlc : null;
        item.dluo = currentLot ? currentLot.dluo : null;
      } else {
        let currentLot = window._.find(
          item.stocks,
          (stk) => stk.entrepot_uuid === this.form.entrepot
        );

        item.stock = currentLot ? currentLot.quantite : 0;
        item.lot = currentLot ? currentLot.lot : null;
        item.dlc = currentLot ? currentLot.dlc : null;
        item.dluo = currentLot ? currentLot.dluo : null;
      }
    },
    onSelectedArticle: function (select) {
      if (select) {
        let lots = select.lots.map((l) => {
          return {
            lot_uuid: l.uuid,
            entrepot_uuid: l.entrepot_uuid,
            lot: l.lot,
            dlc: l.dlc,
            dluo: l.dluo,
            quantite: l.quantite,
          };
        });

        let item = {
          id: null,
          produit: select.resource_uuid,
          designation: select.designation,
          reference: select.reference,
          unite: select.unite,
          lot_uuid: null,
          lot: null,
          dlc: null,
          dluo: null,
          quantite: 0,
          gestion_lot: select.gestion_lot,
          lots: lots,
          stocks: select.stocks,
        };

        this.item_lists.push(item);
        this.stockArticle(item);

        this.searchText = null;
        this.selectedArticle = null;
        this.articles = [];
      }
    },
    async onSearchArticle(search) {
      const lettersLimit = 2;

      this.articles = [];
      this.noData = false;

      if (search.length < lettersLimit || !this.form.entrepot) {
        return;
      }

      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(async () => {
        await window.axios
          .get(URL_A.SEARCH_ARTICLE, {
            params: {
              search: search,
              onlyProduit: true,
              requireLots: true,
              entrepot: this.form.entrepot,
              sortBy: 'designation',
              sortDesc: false,
            },
          })
          .then((resp) => {
            this.articles = resp.data;
          })
          .catch();

        if (!this.articles.length) {
          this.noData = true;
        } else if (this.articles.length === 1) {
          this.onSelectedArticle(this.articles[0]);
        }
      }, 500);
    },
    removeItem: function (index) {
      this.item_lists.splice(index, 1);
    },

    init() {
      this.id = this.$route.params.id;
      this.entrepots = [];
      this.articles = [];
      this.item_lists = [];

      window.axios
        .all([
          window.axios.get(URL_INV.GET_REQUIREMENTS),
          window.axios.get(URL_INV.INVENTAIRE + '/' + this.id, {
            params: { edit: true },
          }),
        ])
        .then(
          window.axios.spread((resp1, resp2) => {
            this.entrepots = resp1.data.entrepots;
            Object.assign(this.form, resp2.data.inventaire);
            this.item_lists = resp2.data.inventaire.item_lists;
            delete this.form.item_lists;
          })
        )
        .catch();
    },
    submit() {
      this.itemListErrorMessage = null;
      this.form.item_lists = this.item_lists.map((item) => {
        let identifiant = item.produit;
        if (item.lot) identifiant += item.lot;
        if (item.dlc) identifiant += item.dlc;
        if (item.dluo) identifiant += item.dluo;

        return {
          id: item.id,
          identifiant: identifiant,
          produit: item.produit,
          designation: item.designation,
          reference: item.reference,
          unite: item.unite,
          lot_uuid: item.lot_uuid || null,
          lot: item.lot || null,
          dlc: item.dlc || null,
          dluo: item.dluo || null,
          quantite: item.quantite,
          gestion_lot: item.gestion_lot,
        };
      });

      this.form.ids = this.form.item_lists
        .filter((item) => item.id !== null)
        .map((item) => item.id);

      this.form
        .put(URL_INV.INVENTAIRE + '/' + this.id)
        .then((resp) => {
          this.showSimpleAlerte('top-end', 'success', resp.data.message);
          if (!this.form.brouillon) {
            this.$router.push({
              name: 'achat_inventaire-show',
              id: this.id,
            });
          }
          this.form.reset();
          this.init();
        })
        .catch((err) => {
          window._.forEach(err.response.data.errors, (value, key) => {
            if (key.includes('item_lists')) {
              this.itemListErrorMessage = value[0];
            } else {
              this.form.errors.set('message', err.response.data.message);
            }
            return 0;
          });
        });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
